import { useCallback, useState } from 'react';

export type UsePaginationResponse = {
  minPage: number;
  maxPage: number;
  nextPage: number;
  awaitingLastPage: boolean;
  awaitingFirstPage: boolean;
  hasMore: boolean;
  onReset: () => void;
  onChangeMinPage: (page: number) => void;
  onChangeMaxPage: (page: number) => void;
  onChangeAwaitingLastPage: (awaiting: boolean) => void;
  onChangeAwaitingFirstPage: (awaiting: boolean) => void;
  onChangeNextPage: (page: number) => void;
  onChangeHasMore: (hasMore: boolean) => void;
};

export const usePagination = (): UsePaginationResponse => {
  const [nextPage, onChangeNextPage] = useState(1);
  const [minPage, onChangeMinPage] = useState(1);
  const [maxPage, onChangeMaxPage] = useState(1);
  const [hasMore, onChangeHasMore] = useState(true);

  const [awaitingLastPage, onChangeAwaitingLastPage] = useState(false);
  const [awaitingFirstPage, onChangeAwaitingFirstPage] = useState(false);

  const onReset = useCallback(() => {
    onChangeNextPage(1);
    onChangeMinPage(1);
    onChangeMaxPage(1);
    onChangeHasMore(true);
    onChangeAwaitingLastPage(false);
    onChangeAwaitingFirstPage(false);
  }, [
    onChangeNextPage,
    onChangeMinPage,
    onChangeMaxPage,
    onChangeHasMore,
    onChangeAwaitingLastPage,
    onChangeAwaitingFirstPage,
  ]);

  return {
    minPage,
    maxPage,
    nextPage,
    hasMore,
    awaitingLastPage,
    awaitingFirstPage,
    onReset,
    onChangeNextPage,
    onChangeMinPage,
    onChangeMaxPage,
    onChangeHasMore,
    onChangeAwaitingLastPage,
    onChangeAwaitingFirstPage,
  };
};
